import { atom } from 'jotai';
import { User, Integration, Patient, Appointment, SyncLog, Referral, PipelineStage } from '../types';

// Mock Users
export const MOCK_USERS: User[] = [
  {
    id: '1',
    email: 'admin@example.com',
    name: 'Admin User',
    role: 'admin',
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    email: 'john@example.com',
    name: 'John Doe',
    role: 'user',
    createdAt: '2024-01-01T00:00:00Z',
  },
];

// Mock Data
export const MOCK_PATIENTS: Patient[] = [
  {
    id: '1',
    externalId: '4D_001',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@example.com',
    phone: '555-0123',
    dateOfBirth: '1980-01-01',
    status: 'active',
    lastSync: '2024-03-01T00:00:00Z',
  },
];

export const MOCK_APPOINTMENTS: Appointment[] = [
  {
    id: '1',
    externalId: '4D_APT_001',
    patientId: '1',
    dateTime: '2024-03-15T10:00:00Z',
    duration: 30,
    type: 'Check-up',
    status: 'scheduled',
    lastSync: '2024-03-01T00:00:00Z',
  },
];

export const MOCK_SYNC_LOGS: SyncLog[] = [
  {
    id: '1',
    user_id: '1',
    type: 'patients',
    direction: 'inbound',
    status: 'success',
    total_count: 10,
    success_count: 10,
    error_count: 0,
    start_time: '2024-03-01T00:00:00Z',
    end_time: '2024-03-01T00:00:10Z',
    details: {
      jobType: 'sync',
      duration_ms: 10000,
      totalCount: 10,
      successCount: 10,
      errorCount: 0,
      message: 'Successfully synced patient data'
    },
    created_at: '2024-03-01T00:00:00Z',
    updated_at: '2024-03-01T00:00:10Z'
  },
];

// Default Integration Configuration
export const DEFAULT_INTEGRATION: Integration = {
  id: '1',
  name: 'Default Integration',
  type: '4d',
  status: 'active',
  config: {
    subscriptionKey: '',
    clientId: '',
    clientSecret: '',
  },
  createdAt: '2024-01-01T00:00:00Z',
  updatedAt: '2024-01-01T00:00:00Z',
};

// Atoms
export const currentUserAtom = atom<User | null>(null);
export const integrationsAtom = atom<Integration[]>([DEFAULT_INTEGRATION]);
export const patientsAtom = atom<Patient[]>([]);
export const appointmentsAtom = atom<Appointment[]>([]);
export const syncLogsAtom = atom<SyncLog[]>([]);
export const syncEnabledAtom = atom<boolean>(false);
export const notificationsAtom = atom<Notification[]>([]);
export const referralsAtom = atom<Referral[]>([]);
export const pipelineStagesAtom = atom<PipelineStage[]>([]);

// Derived atoms for stats
export const statsAtom = atom((get) => {
  const patients = get(patientsAtom);
  const appointments = get(appointmentsAtom);
  const logs = get(syncLogsAtom);

  const successfulSyncs = logs.filter(log => log.status === 'success').length;
  const totalSyncs = logs.length;
  const syncRate = totalSyncs > 0 ? Math.round((successfulSyncs / totalSyncs) * 100) : 100;

  return {
    totalPatients: patients.length,
    totalAppointments: appointments.length,
    syncRate,
    apiHealth: 'Healthy',
  };
});